import CheckboxInput from "components/input/CheckboxInput";
import React from "react";

interface GeneralSemesterOptionProps {
  item: any;
  index: number;
}
export const GeneralSemesterOption = (props: GeneralSemesterOptionProps) => {
  const {item, index} = props;
  const buildName = (name: string) => {
    return `additional_info.course_work[${index}].${name}`;
  };

  let options: any = [];
  switch (item.schedule) {
    case 'Quarters':
      options = [
        { value: 'isFirstSemester', label: 'First Quarter', fieldIndex: 0 },
        { value: 'isSecondSemester', label: 'Second Quarter', fieldIndex: 1 },
        { value: 'isThirdSemester', label: 'Third Quarter', fieldIndex: 2 },
        { value: 'isFourthSemester', label: 'Fourth Quarter', fieldIndex: 3 },
      ];
      break;
    case 'Trimester':
      options = [
        { value: 'isFirstSemester', label: 'First Trimester', fieldIndex: 0 },
        { value: 'isSecondSemester', label: 'Second Trimester', fieldIndex: 1 },
        { value: 'isThirdSemester', label: 'Third Trimester', fieldIndex: 2 },
      ];
      break;
    case 'Semester':
      options = [
        { value: 'isFirstSemester', label: 'First Semester', fieldIndex: 0 },
        { value: 'isSecondSemester', label: 'Second Semester', fieldIndex: 1 },
      ];
      break;
    default:
      break;
  }

  return (
    <>
      <div id={`takeSemester_${index + 1}`}
           className="d-flex pb-2 gm-summary-field-label"
           style={{display: 'inline-block'}}
      >
        During which {item.schedule?.toLowerCase() ?? 'term'}(s) did you take this class? *
      </div>
      {options.map((opt: any, idx: number) => {
        let key = opt.value as any;
        return (
          <CheckboxInput
            logo="check-label"
            className='mb-3 check-blue'
            disabled={true}
            key={index}
            name={buildName(key)}
            label={opt.label}
            values={item?.[key]}
          />
        );
      })}
    </>
  );
};


interface SemesterOptionProps {
  item: any;
  subject:any;
  index: number;
}
export const SemesterOption = (props: SemesterOptionProps) => {
  const {item, subject, index} = props;
  const buildName = (name: string) => {
    return `subjectDetails[${index}].${name}`;
  };

  const options = React.useMemo(() => {
    let arr: any = [];
    switch (item.schedule) {
      case 'Quarters':
        arr = [
          { value: 'isFirstSemester', label: 'First Quarter', fieldIndex: 0 },
          { value: 'isSecondSemester', label: 'Second Quarter', fieldIndex: 1 },
          { value: 'isThirdSemester', label: 'Third Quarter', fieldIndex: 2 },
          { value: 'isFourthSemester', label: 'Fourth Quarter', fieldIndex: 3 },
        ];
        break;
      case 'Trimester':
        arr = [
          { value: 'isFirstSemester', label: 'First Trimester', fieldIndex: 0 },
          { value: 'isSecondSemester', label: 'Second Trimester', fieldIndex: 1 },
          { value: 'isThirdSemester', label: 'Third Trimester', fieldIndex: 2 },
        ];
        break;
      case 'Semester':
        arr = [
          { value: 'isFirstSemester', label: 'First Semester', fieldIndex: 0 },
          { value: 'isSecondSemester', label: 'Second Semester', fieldIndex: 1 },
        ];
        break;
      default:
        break;
    }
    return arr;
  }, [item.schedule]);

  return (
    <>
      <div id={`takeSemester_${index + 1}`}
           className="d-flex pb-2 gm-summary-field-label"
           style={{display: 'inline-block'}}
      >
        During which {item.schedule?.toLowerCase() ?? 'term'}(s) did you take this class? *
      </div>
      {options.map((opt: any, idx: number) => {
        let key = opt.value as any;
        return (
          <CheckboxInput
            logo="check-label"
            className='mb-3 check-blue'
            disabled={true}
            key={index}
            name={buildName(key)}
            label={opt.label}
            values={subject?.[key]}
          />
        );
      })}
    </>
  );
};